import updateDocument from 'api/v2/repository/updateDocument';
import { useMutation, useQueryClient } from 'react-query';
import { DocumentsRepositoryCacheKeys } from 'types/cacheKeys.types';
import showToast from 'utils/toast';

const useUpdateDocument = () => {
  const queryClient = useQueryClient();

  const updateDocumentAPI = useMutation({
    mutationFn: updateDocument,
    onSuccess: () => {
      showToast(
        { title: 'Document updated successfully' },
        { type: 'success' },
      );

      queryClient.invalidateQueries([
        DocumentsRepositoryCacheKeys.DocumentsList,
      ]);
    },
  });

  return updateDocumentAPI;
};

export default useUpdateDocument;
